import { useQuery } from "@tanstack/react-query";
import { MAX_CALLS_TIME_STAMP } from "../call-management.constants.js";
import { useAxiosProvider } from "../components/AxiosProvider/index.js";
import { withQueryParams } from "../helpers/withQueryParams.js";
import "date-fns";
import "react/jsx-runtime";
import "react";
import "axios";
const getCallTasks = (axios) => async (clinicReferenceId, open, signal) => {
  const params = {
    clinicReferenceId,
    size: 1e3,
    page: 0,
    open,
    timeStampAfter: MAX_CALLS_TIME_STAMP
  };
  const { data } = await axios.get("/api/v2/call-tasks", {
    signal,
    params
  });
  return (data == null ? void 0 : data.content) || [];
};
const useCallTasks = ({ key, clinicReferenceId, auth, baseURL, disabled }) => {
  const axios = useAxiosProvider();
  const isOpen = key === "open-call-tasks";
  const queryKey = [key, clinicReferenceId, isOpen];
  const enabled = !disabled && !!clinicReferenceId && !!auth && !!baseURL;
  const { data } = useQuery({
    queryKey,
    queryFn: withQueryParams(getCallTasks(axios)),
    keepPreviousData: true,
    refetchInterval: 1e3 * 60 * 30,
    enabled
  });
  return {
    queryKey,
    data: data ?? []
  };
};
export {
  useCallTasks
};
